'use strict'

class TrashcanOverviewCtrl {

    constructor ($rootScope, $http, $timeout, $state, Item, $mdDialog, $mdToast, paginationService, $scope) {

        // Dependencies
        this.$http = $http
        this.$timeout = $timeout
        this.$state = $state
        this.$scope = $scope
        this._Item = Item
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.paginationService = paginationService
        this.formData = undefined
        this.searchTerm = ''
        this.selectedProgram = ''

        // Controller vars
        this.loaded = false

        // Paginator
        this.pagination = {
            current: 1
        }

        // Watchers
        $rootScope.checkActive = (item) => {
            return ('' + item.id) === ('' + $state.params.id)
        }

        // Fetch the overview items
        this.pageNumber = 1
        this.fetch()
        this.fetchPrograms()

        this.$http.get('/modeltypes_options/item')
            .then((response) => {
                this.item_options = response.data
            })
    }

    fetch (pageNumber = null) {
        if (pageNumber != null) {
            this.pageNumber = pageNumber
        }

        this.loaded = false
        this.$http.get('/trashcan', {
            params: {
                page: this.pageNumber,
                start: this.parseDate(this.$scope.start),
                end: this.parseDate(this.$scope.end),
                keywords: this.$scope.keywords || '',
                program: this.selectedProgram,
            }
        })
            .then(({ data }) => {
                this.items = data.data
                this.totalResults = data.total
                this.resultPerPage = data.per_page
                this.$timeout(() => this.loaded = true)
            })
    }

    fetchPrograms () {
        this.$http.get('/programs/all')
            .then(result => {
                this.programs = result.data
            })

    }

    stopKeyDown (ev) {
        ev.stopPropagation()
    }

    autoFocusSearch () {
        setTimeout(() => {
            $('input#program-search').focus()
        }, 100)
    }

    clearSearchTerm () {
        this.searchTerm = ''
    }

    parseDate (date) {
        if (!(date instanceof Date) || isNaN(date.getTime())) return ''
        return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
    }

    restore (id, ev) {
        ev.stopPropagation()
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirm_restore.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true,
        })
            .then(() => {
                this.$http.post(`items/${encodeURIComponent(id)}/restore`)
                    .then(() => this.fetch())
            })
            .catch()
    }

}

TrashcanOverviewCtrl.$inject = [
    '$rootScope',
    '$http',
    '$timeout',
    '$state',
    'Item',
    '$mdDialog',
    '$mdToast',
    'paginationService',
    '$scope',
    'User',
]

module.exports = TrashcanOverviewCtrl
